define('deco/events',['deco/proclaimWhen'], function(proclaimWhen){
  return proclaimWhen.extend({
    thePageHasChanged: function(path, segments, url){ }
  });
});
